import * as React from "react"
// import { FieldProps } from "formik"

// let multiArray = []

class RegularField extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectValue: null,
      isSelected: false,
      showPlaceholderDate: true,
    }
  }
  render() {
    const { field, type, placeholder, wrapperClassName, disabled, errors, form, label, icon } = this.props
    let formClasses = "form__field"
    formClasses += type ? ` form__field--${type}` : ""
    formClasses += wrapperClassName ? ` form__field--${wrapperClassName} ` : ""
    formClasses += disabled ? " form__field--disabled" : ""
    formClasses += form.touched[field.name] && errors[field.name] ? " form__field--error" : ""

    // if (field.value && this.props.options && this.props.options.find(option => option.value === field.value)) {
    //   console.log(field.value);
    //   this.setState({ isSelected: true, selectValue: this.props.options.find(option => option.value === field.value) });
    // }

    // const onFocus = () => {
    //   this.setState({ isSelected: true })
    // }
    // const onBlur = () => {
    //   this.setState({ isSelected: false })
    // }

    // const handleChange = value => {
    //   if (value && this.props.isMulti) {
    //     multiArray = []
    //     value.map(val => multiArray.push(val.value))
    //     this.props.form.setFieldValue(field.name, multiArray)
    //     this.setState({ selectValue: multiArray.length ? multiArray : "" })
    //   } else if (value && this.props.isPreacher) {
    //     this.props.form.setFieldValue(field.name, [value.value])
    //     this.setState({ selectValue: value })
    //   } else {
    //     this.props.form.setFieldValue(field.name, value ? value.value : "")
    //     this.setState({ selectValue: value })
    //   }
    // }
    // const onChange = e => {
    //   console.log(e.target.files[0])
    //   this.props.form.setFieldValue(field.name, e.currentTarget.files[0])
    // }
    return (
      <div className={formClasses}>
        {type && type === "select" ? (
          <>
            <h1>Select</h1>
          </>
        ) : type && type === "file" ? (
          <>
            <h1>File</h1>
          </>
        ) : type && type === "date" ? (
          <>
            <h1>Date</h1>
          </>
        ) : type && type === "textarea" ? (
          <>
            <label className="field-label" htmlFor={field.name}>
              {label} {form.touched[field.name] && <span className="form__field--label-error">{errors[field.name] && `* ${errors[field.name]}`}</span>}
            </label>
            <textarea
              {...field}
              type={type}
              disabled={form.values.isUnknown}
              onFocus={() => this.setState({ showPlaceholderDate: false })}
              onBlur={() => !form.values.isUnknown && this.setState({ showPlaceholderDate: true })}
              name={field.name}
              placeholder={placeholder}
              onChange={field.onChange}
              checked={field.value}
            />
            {/* {icon && <i className={icon} />} */}
            {/* {errors && form.touched && <div className="form__field--label-error">{form.touched[field.name] && <span>{errors[field.name]}</span>}</div>} */}
          </>
        ) : (
          <>
            {label && (
              <label className="field-label" htmlFor={field.name}>
                {/* {label} {errors && form.touched && <div >{form.touched[field.name] && <span className="form__field--label-error">*{errors[field.name]}</span>}</div>} */}
                {label} {form.touched[field.name] && <span className="form__field--label-error">{errors[field.name] && `* ${errors[field.name]}`}</span>}
              </label>
            )}
            <input autoComplete={field.name === "password" ? "on" : "new-password"} type={type} name={field.name} onChange={field.onChange} value={field.value} placeholder={placeholder} />
            {icon && <img className="icon" src={icon} alt="" />}
          </>
        )}
      </div>
    )
  }
}

export default RegularField
